import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { ar, enUS } from "date-fns/locale";
import { Box, Button, Typography } from "@mui/material";

import { colors } from "../../theme/palette";
import { EventCreatedSuccessfully } from "../../assets/icons/MUI/EventsIcons";
import APP_ROUTES from "../../routers/routeConstants";

const EventCreated = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.res?.data;

  if (!data) {
    return <Navigate to={APP_ROUTES.NOT_FOUND} />;
  }

  const { name, location: eventLocation, startDate } = data;

  const locale = i18n.language === "ar" ? ar : enUS;

  return (
    <Box
      sx={{
        padding: "36px 0",
        background: colors.White,
        borderRadius: "8px",
        border: "1px solid #EAECF0",
        width: "870px",
        overflow: "hidden",
        position: "relative",
        textAlign: "center",
        minHeight: "calc(100vh - 105px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <EventCreatedSuccessfully
        style={{
          marginBottom: "35px",
        }}
      />
      <Typography
        variant="body14SemiBold"
        sx={{
          color: colors.Dark600,
          marginBottom: "5px",
        }}
      >
        {t("pages.events.createEvent.gameCreatedSuccess")}
      </Typography>
      <Typography
        variant="h2ExtraBold"
        sx={{
          color: colors.Dark1000,
          marginBottom: "18px",
        }}
      >
        {name}
      </Typography>
      <Typography
        variant="body14SemiBold"
        sx={{
          color: colors.Dark600,
          marginBottom: "9px",
        }}
      >
        {eventLocation.locationSubTitle}
      </Typography>
      <Typography
        variant="body14SemiBold"
        sx={{
          color: colors.Dark600,
          marginBottom: "46px",
        }}
      >
        {format(new Date(startDate), "EEEE, MMM dd HH:mm", { locale })}
      </Typography>
      <Button variant="primary-sm" onClick={() => navigate(APP_ROUTES.EVENTS)}>
        {t("pages.events.createEvent.checkMyEvents")}
      </Button>
    </Box>
  );
};

export default EventCreated;
